import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
export const MakeAccordian = ({ name, details }) => {
    return (_jsxs(Accordion, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(ExpandMoreIcon, {}), "aria-controls": "panel1a-content" }, { children: _jsx(Typography, { children: name }) })), _jsx(AccordionDetails, { children: details })] }));
};
